export const blockChainEvents = {
    TRANSACTION_HASH: "transactionHash",
    RECEIPT: "receipt",
    CONFIRMATION: "confirmation",
    ERROR: "error",
};
